<!-- Temporary commented, it may be needed in future
<div class="form-group col-lg-4 col-md-6 pt-2">
  <a class="pr-4" href="javascript:void(0);" (click)="handleAddMediaClick()">Add Media</a>
  <app-attachments-preview *ngIf="!showAttachmentInDialog && currentAttachment?.attachmentUIPath" [attachments]="[currentAttachment]" [componentType]="componentTypes.ExperienceComponent"></app-attachments-preview>
</div>
-->

<app-modal #attachmentmodal [modalConfig]="modalConfig">
  <div class="experience-attachment-modal">
    <div class="form-row col-sm-12">
      <span class="span-margin-left-5">Max allowed file size 25MB.</span>
    </div>
    <div class="form-row col-sm-12">
      <div class="form-group col-sm-12">
        <input type="text" class="form-control" #txtTitle placeholder="Title" [(ngModel)]="experienceAttachment.title">
      </div>
    </div>
    <div class="form-row col-sm-12 text-center m-auto">
      <button class="btn btn-sm btn-outline-primary attachment-type-btn col-sm-5 mr-5 rounded-pill" type="button"
        (click)="file.click()">
        File Upload
        <i class="fa fa-check text-success pl-5"
          *ngIf="experienceAttachment.attachmentType == attachmentTypes.File"></i>
      </button>
      <button class="btn btn-sm btn-outline-primary attachment-type-btn col-sm-5 rounded-pill" type="button"
        (click)="experienceAttachment.attachmentType = attachmentTypes.URL">URL
        <i class="fa fa-check text-success pl-5" *ngIf="experienceAttachment.attachmentType == attachmentTypes.URL"></i>
      </button>
    </div>
    <input #file type="file" accept="{{acceptedAttachmentFiles}}" (change)="handleFileUpload(file.files)"
      style="height: 0px;">
    <br>
    <div class="form-row col-sm-12" *ngIf="experienceAttachment.attachmentType == attachmentTypes.URL">
      <div class="form-group col-sm-12">
        <input type="text" class="form-control" #txtUrl="ngModel" placeholder="URL"
          [(ngModel)]="experienceAttachment.url"
          pattern="/\b(https?|ftp|file):\/\/\)?[-A-Za-z0-9+&@#\/%?=~_|!:,.;]+[-A-Za-z0-9+&@#\/%=~_|]/"
          [class.is-invalid]="txtUrl.invalid && txtUrl.touched" required>
        <div *ngIf="txtUrl.errors && (txtUrl.invalid && txtUrl.touched)">
          <small class="text-danger" *ngIf="txtUrl.errors.required">URL is required.</small>
          <small class="text-danger" *ngIf="txtUrl.errors.pattern">Please provide a valid URL.</small>
        </div>
      </div>
    </div>
    <div class="form-row col-sm-12">
      <span *ngIf="!uploadStatus.success" class="text-danger">{{uploadStatus.status}}</span>
      <span *ngIf="formValidationStatus.length > 0" class="text-danger">{{formValidationStatus}}</span>
      <div class="progress upload" *ngIf="uploadStatus.progress > 0 && uploadStatus.progress < 100">
        <div class="progress-bar" [style.width]="uploadStatus.progress + '%'">{{uploadStatus.progress}}%</div>
      </div>
    </div>

    <app-attachments-preview *ngIf="currentAttachment?.attachmentUIPath" [attachments]="[currentAttachment]" [componentType]="componentTypes.ExperienceComponent"></app-attachments-preview>

  </div>
</app-modal>
